import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import ProtectedRoute from '../components/ProtectedRoute';
import Dashboard from '../pages/Dashboard';
import Batches from '../pages/Batches';
import BatchDetails from '../pages/BatchDetails';
import ChangeHistory from '../pages/ChangeHistory';
import Collections from '../pages/Collections';
import HubDetails from '../pages/HubDetails';
import Jobs from '../pages/Jobs';
import JobDetails from '../pages/JobDetails';
import Settings from '../pages/Settings';
import DataFix from '../pages/DataFix';
import ErrorPage from '../pages/ErrorPage';
export const router = createBrowserRouter([
    {
        path: '/',
        element: _jsx(Layout, {}),
        errorElement: _jsx(ErrorPage, {}),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/dashboard", replace: true }),
            },
            {
                path: 'dashboard',
                element: (_jsx(ProtectedRoute, { children: _jsx(Dashboard, {}) })),
            },
            {
                path: 'batches',
                element: (_jsx(ProtectedRoute, { children: _jsx(Batches, {}) })),
            },
            {
                path: 'batches/:batchId',
                element: (_jsx(ProtectedRoute, { children: _jsx(BatchDetails, {}) })),
            },
            {
                path: 'collections',
                element: (_jsx(ProtectedRoute, { children: _jsx(Collections, {}) })),
            },
            {
                path: 'collections/:collectionId',
                element: (_jsx(ProtectedRoute, { children: _jsx(HubDetails, {}) })),
            },
            {
                path: 'jobs',
                element: (_jsx(ProtectedRoute, { children: _jsx(Jobs, {}) })),
            },
            {
                path: 'jobs/:jobId',
                element: (_jsx(ProtectedRoute, { children: _jsx(JobDetails, {}) })),
            },
            {
                path: 'change-history',
                element: (_jsx(ProtectedRoute, { children: _jsx(ChangeHistory, {}) })),
            },
            {
                path: 'data-fix',
                element: (_jsx(ProtectedRoute, { children: _jsx(DataFix, {}) })),
            },
            {
                path: 'settings',
                element: (_jsx(ProtectedRoute, { children: _jsx(Settings, {}) })),
            },
        ],
    },
]);
